import type { SVGProps } from 'react';

export const FaceSad = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="512px"
    role="img"
    viewBox="0 0 512 512"
    width="512px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'face sad'}</title>
    <g transform="scale(1,-1) translate(0 -512)">
      <path
        d="M256 479c124 0 223-100 223-223 0-124-100-225-223-225-124 0-223 101-223 225 0 124 99 223 223 223m0 33c-141 0-256-113-256-256 0-141 115-256 256-256 141 0 256 115 256 256 0 141-115 256-256 256m-4-338c-42 0-82-22-106-57-2-4-2-9 2-11 4-2 9-2 11 2 20 31 55 49 93 49 41 0 77-22 97-55 2-3 8-5 11-3 4 2 6 7 4 11-26 40-68 64-112 64m-122 69c0-2 0-3 2-5 1-4 7-4 11-2l49 38c2 2 4 4 4 6 0 2-2 5-4 5l-44 39c-2 5-7 3-11 1-4-3-2-9 2-10l37-32-43-32c-1-2-3-6-3-8m247 0c0 2-2 6-4 6l-42 33 37 31c3 3 3 7 1 11-3 3-7 3-11 1l-43-38c-2-2-4-4-4-5 0-2 2-6 4-6l49-38c4-2 9-2 11 2 2 0 2 1 2 3"
        fill={props.fill}
      />
    </g>
  </svg>
);
